import APIService from "./APIService";
import { getInstance } from "../auth/auth";

const http = APIService.http;

export default {
  async getLeadOrders() {
    let auth = getInstance();
    let authHeaders = await auth.apiAuthConfigWithCompanyHeader();
    let res = await http.get(`api/LeadOrders`, authHeaders);
    let leadOrders = res.data;
    return leadOrders;
  },

  async getLeadOrder(leadOrderId) {
    let auth = getInstance();
    let authHeaders = await auth.apiAuthConfigWithCompanyHeader();
    let res = await http.get(`api/LeadOrders/${leadOrderId}`, authHeaders);
    let leadOrders = res.data;
    return leadOrders;
  },

  async getLeadOrderLeads(leadOrderId) {
    let auth = getInstance();
    let authHeaders = await auth.apiAuthConfigWithCompanyHeader();
    let res = await http.get(`api/LeadOrders/${leadOrderId}/leads`, authHeaders);
    let leadOrders = res.data;
    return leadOrders;
  }
};
